import { render, staticRenderFns } from "./createProduct.vue?vue&type=template&id=81d13af6&scoped=true"
import script from "./createProduct.vue?vue&type=script&lang=js"
export * from "./createProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d13af6",
  null
  
)

export default component.exports